require('./ctxClickableTags.style.scss');

class ctxClickableTagsController {
    constructor($scope) {
        this.$scope = $scope;
        let unwatch = this.$scope.$watch(() => this.tags, tags => {
            if (!tags) return;
            this.selectedTags = this.tags.filter(item => item.selected).map(i => i.value);
            unwatch();
        });
    }

    onTagClick(tag) {
        if (this.singleSelect) this.tags.forEach(item => item.selected = false);
        if (tag && !tag.isDefault) tag.selected = !tag.selected;
        this.selectedTags = this.tags.filter(item => item.selected).map(i => i.value);
    }
}

ctxClickableTagsController.$inject = ['$scope'];

const ctxClickableTagsComponent = {
    controller: ctxClickableTagsController,
    template: require('./ctxClickableTags.template.html'),
    scope: {},
    bindings: {
        label: '@?',
        tags: '=',
        selectedTags: '=',
        disabled: '<',
        singleSelect: '<',
    }
};

module.exports = ctxClickableTagsComponent;



// WEBPACK FOOTER //
// ./src/shared/ctxClickableTags/ctxClickableTags.component.js